import { render } from "./ShopServiceItem.vue?vue&type=template&id=135b2ba3"
import script from "./ShopServiceItem.vue?vue&type=script&lang=js"
export * from "./ShopServiceItem.vue?vue&type=script&lang=js"

import exportComponent from "/Users/vixfs/PhpstormProjects/fitbase/frontend/web/vue-resources/personal-account/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__